<xt-ui-kit-dialog
  *transloco="let t"
  [actionsTemplate]="actionsTemplate()"
  [config]="config()"
>
  <p class="step">
    {{ t('app.dialog.addDocument.step') }} {{ currentStep() }}
    {{ t('app.dialog.addDocument.of') }} {{ stepCount() }}
  </p>
  <div>
    <div class="dialog-header">
      <h1 class="step-header">{{ stepHeader() }}</h1>
    </div>
    <mat-progress-bar
      class="progress-bar"
      [mode]="'determinate'"
      [value]="progressValue"
    />
    <div class="dialog-content">
      <ng-container *ngTemplateOutlet="contentTemplate()" />
    </div>
  </div>
</xt-ui-kit-dialog>